<template>
  <div class="page-content">
    <div class="header">
      <img src="../assets/imgs/logo.png">
      皓尨仓管PDA
    </div>
    <div class="form">
      <van-cell-group>
        <van-field left-icon="manager" v-model="name" placeholder="请输入用户名"/>
        <van-field left-icon="lock" type="password" v-model="pwd" placeholder="请输入密码" adjust-position @keyup.enter="memberLogin"/>
      </van-cell-group>
    </div>
    <div class="sub-button">
      <label @click="memberLogin">登录</label>
    </div>
  </div>
</template>

<script>
import StorageUtil from "../util/storage.js";

export default {
  data() {
    return {
      name: "",
      pwd: ""
    };
  },
  methods: {
    // 登录
    memberLogin() {
      let param = {
        account: this.name,
        password: this.pwd
      };
      this.$post(this.URL.login, param).then(res => {
        console.log(res);
        if (res.success) {
          if (res.data.warehouseIds && res.data.warehouseIds.length > 0) {
            localStorage.setItem("token", res.data.loginToken);
            // 记录绑定仓库ID --- 未绑定登录无效
            localStorage.setItem("ownWarehouseId", res.data.warehouseIds);
            let member = {
              userName: res.data.userName,
              mobile: res.data.mobile,
              id: res.data.id,
              ownWarehouseIds: res.data.warehouseIds
            };
            StorageUtil.setLocalStorage("member", member);
            this.$router.push("/index");
          } else {
            this.$toast.fail("该用户未绑定仓库");
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  width: 100%;
  height: 10rem;
  background-color: #dc6350;
  color: #ffffff;
  font-size: 24px;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  img {
    width: 3rem;
    height: 3rem;
    border-radius: 2.5rem;
  }
}

.form {
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 3rem 0;

  .van-cell-group {
    display: inline-flex;
    width: 80%;
    flex-wrap: wrap;
    border: none;

    .van-cell {
      width: 100%;
      font-size: 0.9rem;
      border: 1px solid #dc6350;
      border-radius: 0.3rem;

      input {
        font-size: 0.9rem;
      }
    }

    .van-cell:last-child {
      margin-top: 2rem;
    }
  }
}

.sub-button {
  display: flex;
  width: 100%;
  justify-content: center;

  label {
    display: inline-flex;
    width: 80%;
    height: 2.5rem;
    border-radius: 0.3rem;
    background-color: #dc6350;
    color: white;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue